// @flow

export const LIST_STATES: 'list/states' = 'list/states';
export const CITIES_STATE_LIST: 'list/states/cities' = 'list/states/cities';
export type Action =
  | {
    type: typeof LIST_STATES,
    params: {}
  }
  | {
    type: typeof CITIES_STATE_LIST,
    cities: {}
  }
;
